import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as config from '../config';
import './login.css';

function Profile() {
    const [supplierBills, setSupplierBills] = useState([]);
    const [error, setError] = useState(null);

    const navigate = useNavigate();
    const loginId = localStorage.getItem('login_id');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${config.DevelopmentUri}/api/Report/GetSupplierProfileInfoReport/${loginId}`);
                setSupplierBills(response.data);
            }
            catch (error) {
                setError(error.response ? error.response.data : error.message);
            }
        };
        if (loginId) {
            fetchData();
        } else {
            navigate('/login');
        }
    }, [loginId, navigate]);


    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className='MainReport'>
            <h1 className='heading'>Profile</h1>
            <div id="ProfileReport">
                {supplierBills.map((bill, index) => (
                    <div key={bill.id}>
                        <div className='profile-container'>
                            <div className='supplierProfile'>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>Supplier Name &nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.supplierName}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>NID Number &nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.supplierNid}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>Mobile Number&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; </b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.supplierMobile}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>Supplier Type&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.SupplierType}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>TIN No.&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.supplierMobile}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>BIN Number&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.SupplierBinNo}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>Address&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.SupplierAddress}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>Bank Name&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.BankName}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>Bank Branch Name&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.BankBranchName}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>Bank A/C No&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.BankAcNo}
                                        </h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>
                                            <b>Security Clearance &nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
                                        </h6>
                                    </td>
                                    <td>
                                        <h6>
                                            {bill.SecurityClearance}
                                        </h6>
                                    </td>
                                </tr>
                            </div>
                            <div className='profile-img'>
                                <img src={`http://103.107.184.30/${bill.vendorPicture}`} alt="Pic" />
                            </div>
                        </div>
                        <h1 className='heading'><span>Company Information</span></h1>
                        <div>
                            <tr>
                                <td>Company Name &nbsp;</td>
                                <td>:&nbsp;&nbsp;</td>
                                <td>{bill.coName}</td>
                            </tr>
                            <tr>
                                <td>Company Name Bangla &nbsp;</td>
                                <td>:</td>
                                <td>{bill.coNameBangla}</td>
                            </tr>
                            <tr>
                                <td>Company Registration No &nbsp;</td>
                                <td>:</td>
                                <td>{bill.coRegistrationNo}</td>
                            </tr>
                            <tr>
                                <td>Company's Legal Status  &nbsp;</td>
                                <td>:</td>
                                <td>{bill.coLegalStatus}</td>
                            </tr>
                            <tr>
                                <td>Company's Establishment Year &nbsp;</td>
                                <td>:</td>
                                <td>{bill.coEstablishmentYear}</td>
                            </tr>
                            <tr>
                                <td>CTrade Licence Issue Date &nbsp;</td>
                                <td>:</td>
                                <td>{bill.tradeLicenceIssueDate}</td>
                            </tr>
                            <tr>
                                <td>Trade Licence Expiry Date &nbsp;</td>
                                <td>:</td>
                                <td>{bill.tradeLicenceExpiryDate}</td>
                            </tr>
                            <tr>
                                <td>Nature of Business &nbsp;</td>
                                <td>:</td>
                                <td>{bill.natureOfBusiness}</td>
                            </tr>
                            <tr>
                                <td>Registered Address &nbsp;</td>
                                <td>:</td>
                                <td>{bill.registeredAddress}</td>
                            </tr>
                            <tr>
                                <td>Address &nbsp;</td>
                                <td>: </td>
                                <td>{bill.headOfficeAddress}</td>
                            </tr>
                            <tr>
                                <td>Phone No &nbsp;</td>
                                <td>:</td>
                                <td>{bill.headOfficePhoneNo}</td>
                            </tr>
                            <tr>
                                <td>Fax No. &nbsp;</td>
                                <td>:</td>
                                <td>{bill.HeadOfficeFaxNo}</td>
                            </tr>
                            <tr>
                                <td>Company's Website &nbsp;</td>
                                <td>:</td>
                                <td>{bill.Website}</td>
                            </tr>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Profile;
